var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5922_26227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0005 2.00195C14.0005 0.897384 14.8959 0.00195312 16.0005 0.00195312H32.0005C33.1051 0.00195312 34.0005 0.897384 34.0005 2.00195V8.00195H46.0005C47.1051 8.00195 48.0005 8.89738 48.0005 10.002V30.002C48.0005 31.1065 47.1051 32.002 46.0005 32.002H32.0005V34.002C32.0005 35.1065 31.1051 36.002 30.0005 36.002H18.0005C16.8959 36.002 16.0005 35.1065 16.0005 34.002V32.002H2.00049C0.895919 32.002 0.000488281 31.1065 0.000488281 30.002V10.002C0.000488281 8.89738 0.895919 8.00195 2.00049 8.00195H14.0005V2.00195ZM4.00049 12.002V28.002H16.0005V26.002C16.0005 24.8974 16.8959 24.002 18.0005 24.002H30.0005C31.1051 24.002 32.0005 24.8974 32.0005 26.002V28.002H44.0005V12.002H4.00049ZM30.0005 8.00195H18.0005V4.00195H30.0005V8.00195ZM28.0005 28.002H20.0005V32.002H28.0005V30.0047C28.0005 30.0038 28.0005 30.0029 28.0005 30.002C28.0005 30.001 28.0005 30.0001 28.0005 29.9992V28.002ZM4.00049 34.002C5.10506 34.002 6.00049 34.8974 6.00049 36.002V44.002H42.0005V36.002C42.0005 34.8974 42.8959 34.002 44.0005 34.002C45.1051 34.002 46.0005 34.8974 46.0005 36.002V46.002C46.0005 47.1065 45.1051 48.002 44.0005 48.002H4.00049C2.89592 48.002 2.00049 47.1065 2.00049 46.002V36.002C2.00049 34.8974 2.89592 34.002 4.00049 34.002Z",
    fill: "#C7C5CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5922_26227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.08755de2.svg";
export { ForwardRef as ReactComponent };